import React, { Component } from "react";

class MenuClose extends Component {
  render() {
    return (
      <div className="menu__info" onMouseDown={this.props.handleMouseDown}>
          <span>Info</span></div>
    );
  }
}

export default MenuClose;



// WEBPACK FOOTER //
// ./src/components/MenuClose.jsx